// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1X0Pc","gfeWrapper":"CalendarEvent_gfeWrapper__vra6_"};